import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// Registers window.snapSaveState for react-snap on every route (not only
// pages that import it), so the text-node fix applies site-wide.
import "@/lib/prerender-data";

// Supports react-snap prerendering: when static HTML already exists in #root
// (a prerendered route), hydrate it; otherwise mount normally. Keeps the
// standard CRA build working unchanged when prerendering is not used.
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(
        rootElement,
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
} else {
    ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
}
